import { type SVGProps } from 'react';

interface SearchIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export function SearchIcon({
  size = 16,
  className,
  ...props
}: SearchIconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        stroke="#202224"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.5"
      />
    </svg>
  );
}
